<!-- src/App.vue -->
<template>
  <v-app>
    <v-app-bar flat app prominent class="multi-line-app-bar">
      <!-- Hamburger Icon only on Mobile -->
      <v-app-bar-nav-icon class="d-md-none" @click="drawer = !drawer" />

      <v-toolbar-title class="multi-line-title">
        KASSANDRA JO<br class="d-md-none" />
        TOMARAS
      </v-toolbar-title>

      <v-spacer class="d-none d-lg-none" />

      <!-- Desktop Menu -->
      <v-btn
        text
        class="button-margin d-none d-md-flex"
        component="router-link"
        to="/"
      >
        About
      </v-btn>
      <v-btn
        text
        class="button-margin d-none d-md-flex"
        component="router-link"
        to="/contact"
      >
        Contact
      </v-btn>
      <v-btn
        text
        class="button-margin d-none d-md-flex"
        component="router-link"
        to="/publications"
      >
        Publications
      </v-btn>
      <v-btn
        text
        class="button-margin d-none d-md-flex"
        component="router-link"
        to="/projects"
      >
        Projects
      </v-btn>
    </v-app-bar>

    <!-- Mobile Drawer -->
    <v-navigation-drawer v-model="drawer" temporary class="mobile-drawer">
      <v-list>
        <v-list-item
          link
          component="router-link"
          to="/"
          @click="drawer = false"
        >
          <v-list-item-title>About</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          component="router-link"
          to="/contact"
          @click="drawer = false"
        >
          <v-list-item-title>Contact</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          component="router-link"
          to="/publications"
          @click="drawer = false"
        >
          <v-list-item-title>Publications</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          component="router-link"
          to="/projects"
          @click="drawer = false"
        >
          <v-list-item-title>Projects</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main class="background-color">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      drawer: false,
    };
  },
};
</script>

<style>
/* Page background: Cream */
.v-app {
  background-color: #f0e6d2;
}

/* App bar: subtle Warm Gray contrast to cream */
.multi-line-app-bar {
  height: auto !important;
  min-height: 96x; /* keep as-is per layout */
  overflow: visible !important;
  background-color: #cac4c3;
  border-bottom: 1px solid #cac4c3;
}

/* Title stays Charcoal for readability */
.multi-line-app-bar .v-toolbar-title {
  color: #3e3e3e;
}

/* Button text Lilac, hover state Sage */
.button-margin {
  padding-right: 5vw;
  color: #c8a2c8 !important;
  transition: background-color 0.3s ease;
}
.button-margin:hover {
  background-color: rgba(163, 177, 138, 0.15);
}

/* Title wrapping & spacing (unchanged) */
.multi-line-title {
  white-space: normal;
  line-height: 1;
  padding-top: 1rem;
}

/* Toolbar title sizing & padding (unchanged) */
.v-toolbar-title {
  font-size: 1em;
  padding-left: 7.5vw;
  padding-top: 0.5rem;
}

.background-color {
  background-color: #f0e6d2;
}

/* Mobile Drawer Styling */
.mobile-drawer {
  background-color: #f0e6d2;
  border-right: 1px solid #cac4c3;
}
.mobile-drawer .v-list-item-title {
  color: #3e3e3e;
}

/* Responsive layout rules (preserved and slightly cleaned) */
@media (max-width: 400px) {
  .multi-line-app-bar {
    padding: 0 16px;
    height: auto !important;
    min-height: 76px;
    overflow: visible !important;
  }
  .multi-line-title {
    font-size: 1em;
    line-height: 1.2;
    padding-top: 0.5rem;
    transform: translateX(-24px);
  }
}
@media (min-width: 400px) {
  .multi-line-app-bar {
    padding: 0 32px;
    height: auto !important;
    min-height: 76px;
    overflow: visible !important;
  }
  .multi-line-title {
    font-size: 1.1em;
    line-height: 1.2;
    padding-top: 0.5rem;
    transform: translateX(-24px);
  }
}
@media (min-width: 960px) {
  .multi-line-app-bar {
    padding: 0 48px;
    height: auto !important;
    min-height: 76px;
    overflow: visible !important;
  }
  .multi-line-title {
    font-size: 2em;
    line-height: 1.2;
    padding-top: 0.5rem;
  }
}
@media (min-width: 1264px) {
  .multi-line-app-bar {
    padding: 0 64px;
    height: auto !important;
    min-height: 76px;
    overflow: visible !important;
  }
  .multi-line-title {
    font-size: 2em;
    line-height: 1.2;
    padding-top: 0.5rem;
  }
}
</style>
